export default "<full-calendar class [options]=\"calendarOptionsForAttendance\"></full-calendar>\r\n"